<template>
    <div>
<!--        <h3 class="detail_title">#{{titleInfo.caseNo}}   {{titleInfo.name}}</h3>-->
        <ul class="record">
            <li class="flex">
                <div class="trait"><i class="el-icon-s-custom"></i></div>
                <ul class="record_right">
                    <li><span style="font-weight: bold">我 · </span>{{format(titleInfo.createdAt)}}</li>
                    <li v-for="(item,index) in detailInfo" :key="index" class="ft500">
                        <span>{{item.label}}：</span>
                        <span>{{item.text?item.text:item.value}}</span>
                    </li>
                </ul>
            </li>
            <li class="flex" v-for="item in records" :key="item.id">
                <div class="trait" :style="{background:item.ownerName!='我'?'#ffc107':''}"><i class="el-icon-s-custom"></i></div>
                <ul class="record_right">
                    <li><span style="font-weight: bold">{{item.ownerName}} · </span>{{item.updatedAt}}</li>
                    <li class="text item">
                        {{item.content}}
                    </li>
                    <li class="file_box">
                        <div v-for="i in item.contentFile" :key="i.fileId">
                                <el-image
                                        v-if="isImage(i.fileName)"
                                        style="width: 100px; height: 100px"
                                        :src="i.fileUrl"
                                        :preview-src-list="[i.fileUrl]">
                                </el-image>

<!--                            <img v-if="isImage(i.fileName)" :src="i.fileUrl" :download="i.fileName" :alt="i.fileName"/>-->
                            <div v-if="isVideo(i.fileName)">
                                <video  width="200px" height="180px" controls class="column">
                                    <source  :src="i.fileUrl">
                                </video>
<!--                                <span>{{i.fileName}}</span>-->
                            </div>
                            <div class="doc" v-if="!isImage(i.fileName) && !isVideo(i.fileName)">
                                <i class="el-icon-document"></i>
                                <a :href="i.fileUrl" :download="i.fileName">{{i.fileName}}</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
            <li class="flex sticky">
                <div class="trait"><i class="el-icon-s-custom"></i></div>
                <ul class="record_right">
                    <li><span style="font-weight: bold">回复内容</span></li>
                    <li class="text item">
                        <el-input type="textarea"
                                  :autosize="{ minRows: 3, maxRows: 10}" resize="none"
                                  maxlength="500"
                                  show-word-limit
                                  v-model="answer"></el-input>
                    </li>
                    <li>
                        <el-upload ref="upload"
                                   class="upload"
                                   action="#"
                                   multiple
                                   :on-change="onChange"
                                   :limit="10"
                                   :on-exceed="handleExceed"
                                   :auto-upload="false"
                                   :file-list="fileList">
                            <el-button size="small"><i class="el-icon-plus"></i>添加附件</el-button>
                        </el-upload>
                    </li>
                    <li class="answer_btn_box"><el-button type="primary" @click="updateInfo">回复</el-button></li>
                </ul>

            </li>
        </ul>
        <el-card class="info_card">
            <p class="info_title">详细信息</p>
            <ul>
                <li>
                    <span>问题分类：</span>
                    <span class="ft100">{{titleInfo.typeText}}</span>
                </li>
                <li>
                    <span>工单描述：</span>
                    <span class="ft100">{{titleInfo.caseDescription?titleInfo.caseDescription:'--'}}</span>
                </li>
                <li>
                    <span>提交时间：</span>
                    <span class="ft100">{{format(titleInfo.createdAt)}}</span>
                </li>
                <li>
                    <span>受理时间：</span>
                    <span class="ft100">{{format(titleInfo.SVCStartTime__c)}}</span>
                </li>
                <li>
                    <span>工单状态：</span>
                    <span class="ft100">{{titleInfo.statusText}}</span>
                </li>
                <li>
                    <span>服务反馈：</span>
                    <span class="ft100">{{titleInfo.feedback__c}}</span>
                </li>
            </ul>
<!--            <div v-for="(item,index) in detailInfo" :key="index" class="text item">-->
<!--                <span>{{item.label}}</span>:-->
<!--                <span>{{item.value}}</span>-->
<!--            </div>-->
        </el-card>
    </div>
</template>

<script>
    import {getCaseDetail, createRecord, getRecord, fileLoad,downLoadImages, createCase} from '../request/api'
    export default {
        name: "orderDetail",
        props:[
            'id'
        ],
        data(){
            return {
                ownerId:'',
                maxSize:83886080,//80*1024*1024
                fileList:[],
                answer:'',
                answerFlag:true,
                titleInfo:{name:''},
                detailInfo:[],
                records:[], //活动记录
                types:[
                    // {
                    //     value: 1,
                    //     label: '硬件设备故障申报',
                    //     children:[
                    //         {
                    //             value: 1,
                    //             label: '硬件寄修申请'
                    //         },
                    //         {
                    //             value: 2,
                    //             label: '硬件换货申请'
                    //         },
                    //         {
                    //             value: 5,
                    //             label: '服务器硬件'
                    //         }
                    //     ]
                    // },
                    // {
                    //     value: 2,
                    //     label: '产品使用咨询',
                    //     children:[
                    //         {
                    //             value: 3,
                    //             label: '技术问题或工具提供'
                    //         },
                    //         {
                    //             value: 4,
                    //             label: '技术支持-远程指导'
                    //         }
                    //     ]
                    // },
                    {
                        value: 4,
                        label: '企业业务',
                        children:[
                            {
                                value: 8,
                                label: '设备返修'
                            },
                            {
                                value: 7,
                                label: 'KOALA商业智能解决方案'
                            },
                            {
                                value: 9,
                                label: 'IPC/NVR'
                            },
                            {
                                value: 10,
                                label: '九霄云平台'
                            },
                            {
                                value: 11,
                                label: '神行面板机'
                            },
                            {
                                value: 12,
                                label: '鸿图系列'
                            },
                            {
                                value: 13,
                                label: '盘古系列'
                            },
                            {
                                value: 14,
                                label: '魔方系列'
                            }
                        ]
                    },
                    {
                        value: 1,
                        label: '城市业务',
                        children: [
                            {
                                value: 1,
                                label: '硬件寄修申请'
                            },
                            {
                                value: 2,
                                label: '硬件换货申请'
                            },
                            {
                                value: 5,
                                label: '服务器硬件'
                            },
                            {
                                value: 3,
                                label: '技术问题或工具提供'
                            },
                            {
                                value: 4,
                                label: '技术支持-远程指导'
                            }
                        ]
                    }
                    // {
                    //     value: 5,
                    //     label: '软件平台故障申报',
                    //     children:[
                    //         {
                    //             value: 15,
                    //             label: '系统无法登录访问'
                    //         },
                    //         {
                    //             value: 16,
                    //             label: '系统功能异常'
                    //         },
                    //         {
                    //             value: 17,
                    //             label: '无告警或推送延迟'
                    //         },
                    //         {
                    //             value: 18,
                    //             label: '无抓拍或漏拍'
                    //         }
                    //     ]
                    // },
                    // {
                    //     value: 6,
                    //     label: '智慧城市-服务请求',
                    //     children:[
                    //         {
                    //             value: 6,
                    //             label: '服务请求'
                    //         }
                    //     ]
                    // },
                ],
                formItems:[
                    {
                        value: 1, entityType: '2290534307745119', items: [  //硬件寄修
                            {value: 'SN__c', label: '设备SN号'},
                            {value: 'amount__c', label: '设备数量'},
                            {value: 'companyName__c', label: '公司名称'},
                            {value: 'address__c', label: '客户地址'},
                            {value: 'contactmobile__c', label: '联系电话'},
                            {value: 'contactName', label: '联系人姓名'},
                            {value: 'productModel__c', label: '产品型号'}]
                    },
                    {value:2,entityType:'2290534298570069',items:[  //硬件换货
                            {value:'productModel__c',label:'换货产品型号'},
                            {value:'amount__c',label:'申请换货设备数量'},
                            {value:'companyName__c',label:'公司名称'},
                            {value:'returnAddress__c',label:'寄回地址'},
                            {value:'contactName',label:'联系人姓名'},
                            {value:'contactmobile__c',label:'联系电话'},
                            {value:'SN__c',label:'设备SN号'},
                            {value:'exchangeReason__c',label:'申请换货原因'}
                        ]},
                    {value:5,entityType:'2290534320606530',items:[  //服务器硬件
                            {value:'reportedFrom__c',label:'故障来源'},
                            {value:'project__c-label',label:'项目编号'},
                            {value:'SN__c',label:'设备SN号'},
                            {value:'productModel__c',label:'产品型号'},
                            {value:'manufacturer__c',label:'厂商'},
                            {value:'currentStage__c',label:'所处阶段'},
                            {value:'serverLocation__c',label:'服务器所处位置'},
                            {value:'takeAway__c',label:'坏件是否可以带走'},
                            {value:'deliverMode__c',label:'交付模式'}
                            ]},
                    {value:3,entityType:'2290534298570071',items:[  //技术支持
                            {value:'productModel__c',label:'产品型号'},
                            {value:'productType__c',label:'使用产品'}
                        ]},
                    {value:4,entityType:'2290534298570071',items:[  //技术支持
                            {value:'productModel__c',label:'产品型号'},
                            {value:'productType__c',label:'使用产品'}
                        ]},
                    {value:7,entityType:'2290534320606534',items:[  //koala
                            {value:'issueType__c',label:'问题分类'},
                            {value:'deviceType__c',label:'设备类型'}
                        ]},
                    {value:8,entityType:'2290534307745098',items:[  //设备返修
                            {value:'issueAppear__c',label:'故障出现阶段'},
                            {value:'acceComplete__c',label:'配件是否齐全'},
                            {value:'SN__c',label:'设备SN号'},
                            {value:'expressNo__c',label:'返修快递单号'},
                            {value:'companyName__c',label:'客户名称'},
                            {value:'address__c',label:'客户地址'},
                            {value:'contactName',label:'联系人姓名'},
                            {value:'contactmobile__c',label:'联系电话'},
                            {value:'htbh__c',label:'合同编号'}
                        ]},
                    {value:9,entityType:'2290534304845061',items:[ //ipc/nvr
                            {value:'issueType__c',label:'问题分类'},
                            {value:'IPCType__c',label:'IPC型号'}
                        ]},
                    {value:10,entityType:'2290534307745100',items:[ {value:'issueType__c',label:'问题分类'}]},  //九霄云平台
                    {value:11,entityType:'2290534300863763',items:[  //神行面板机
                            {value:'issueType__c',label:'问题分类'},
                            {value:'SXType__c',label:'神行面板机型号'}
                       ]},
                    {value:12,entityType:'2290534331190607',items:[ //鸿图系列
                            {value:'issueType__c',label:'问题分类'},
                            {value:'HTType__c',label:'鸿图型号'}
                       ]},
                    {value:13,entityType:'2290534245731616',items:[{value:'issueType__c',label:'问题分类'}]},  //盘古系列
                    {value:14,entityType:'2290534304845095',items:[  //魔方系列
                            {value:'issueType__c',label:'问题分类'},
                            {value:'MFType__c',label:'魔方型号'}
                        ]},
                    {value:6,entityType:'2290534300863765',items:[{value:'supportOrg__c',label:'受理组织'},{value:'projName__c',label:'项目名称'},{value:'project__c-label',label:'项目编号'}]},
                    {value:15,entityType:'2290534304845097',items:[{value:'productType__c',label:'使用产品'}]},
                    {value:16,entityType:'2290534304845097',items:[{value:'productType__c',label:'使用产品'}]},
                    {value:17,entityType:'2290534304845097',items:[{value:'productType__c',label:'使用产品'}]},  //软件平台故障申报
                    {value:18,entityType:'2290534304845097',items:[{value:'productType__c',label:'使用产品'}]}
                ],
                caseStatus:[
                    {value:1,label:'待分配'},
                    {value:2,label:'待处理'},
                    {value:3,label:'处理中'},
                    {value:4,label:'待回复'},
                    {value:5,label:'已解决'},
                    {value:6,label:'已完成'}
                ],
                supportOrgs:[ //受理组织
                    {
                        label:'运维组',
                        value:1
                    },
                    {
                        label:'技术支持组',
                        value:2
                    }
                ],
                productTypes:[ //使用产品
                    {
                        label:'硬件-相机类',
                        value:1
                    },
                    {
                        label:'硬件-明骥测温',
                        value:2
                    },
                    {
                        label:'硬件-视频解析盒子类',
                        value:3
                    },
                    {
                        label:'硬件-便携类',
                        value:21
                    },
                    {
                        label:'硬件-服务器类',
                        value:4
                    },
                    {
                        label:'其他',
                        value:20
                    },
                    {
                        label:'软件-BootOs',
                        value:5
                    },
                    {
                        label:'软件-Core',
                        value:6
                    },
                    {
                        label:'软件-洞鉴-人像大数据平台',
                        value:7
                    },
                    {
                        label:'软件-灵探-全目标解析实战平台',
                        value:8
                    },
                    {
                        label:'软件-慧寻-视图大数据平台',
                        value:9
                    },
                    {
                        label:'软件-昆仑-视图大数据综合应用平台',
                        value:10
                    },
                    {
                        label:'软件-万象-城市管理视频识别',
                        value:11
                    },
                    {
                        label:'软件-天目V1-人像大数据平台',
                        value:12
                    },
                    {
                        label:'软件-天宫V3-人像大数据平台',
                        value:13
                    },
                    {
                        label:'软件-云桥',
                        value:14
                    },
                    {
                        label:'软件-云图',
                        value:15
                    },
                    {
                        label:'软件-锐眸-眼镜',
                        value:16
                    },
                    {
                        label:'软件-Armour',
                        value:17
                    },
                    {
                        label:'软件-天眼2.0',
                        value:18
                    },
                    {
                        label:'软件-Swarm',
                        value:19
                    }
                ],
                reportedFroms:[ //故障来源
                    {
                        label:'客户发现',
                        value:1
                    },
                    {
                        label:'项目经理发现',
                        value:2
                    },
                    {
                        label:'其他人员发现',
                        value:3
                    }
                ],
                manufacturers:[ //厂商
                    {
                        label:'宝德',
                        value:1
                    },
                    {
                        label:'浪潮',
                        value:2
                    },
                    {
                        label:'安擎',
                        value:3
                    }
                ],
                currentStages:[ //所处阶段
                    {
                        label:'售后服务',
                        value:1
                    },
                    {
                        label:'项目实施',
                        value:2
                    }
                ],
                deliverModes:[   //交付模式
                    {
                        label:'项目',
                        value:1
                    },
                    {
                        label:'代理商',
                        value:2
                    }
                ],
                issueAppears:[ //故障出现阶段
                    {
                        label:'到货即损',
                        value:1
                    },
                    {
                        label:'使用一段时间后',
                        value:2
                    },
                    {
                        label:'不确定',
                        value:3
                    }
                ],
                acceCompletes:[ //配件是否齐全
                    {
                        label:'齐全（包装+配件）',
                        value:1
                    },
                    {
                        label:'不齐全（在工单中说明寄回了哪些包装配件）',
                        value:2
                    },
                    {
                        label:'只有裸机',
                        value:3
                    }
                ],
                issueTypes:[ //问题分类
                    {
                        label:'产品缺陷或限制',
                        value:1
                    },
                    {
                        label:'API相关问题',
                        value:2
                    },
                    {
                        label:'操作配置问题',
                        value:3
                    },
                    {
                        label:'远程排查调试',
                        value:4
                    },
                    {
                        label:'客户需求',
                        value:5
                    },
                    {
                        label:'其他Q&A',
                        value:6
                    },
                    {
                        label:'硬件故障',
                        value:7
                    },
                    {
                        label:'升级相关',
                        value:8
                    },
                    {
                        label:'硬件故障（非缺陷）',
                        value:9
                    },
                    {
                        label:'现场环境版本兼容性问题',
                        value:10
                    },

                ],
                deviceTypes:[ //设备类型
                    {
                        label:'koala主机',
                        value:1
                    },
                    {
                        label:'相机',
                        value:2
                    },
                    {
                        label:'M5M5E45S',
                        value:3
                    },
                    {
                        label:'人证访客',
                        value:4
                    },
                    {
                        label:'koala lite',
                        value:5
                    },
                    {
                        label:'tv盒子',
                        value:6
                    },
                    {
                        label:'其他',
                        value:7
                    }
                ],
                IPCTypes:[ //IPC型号
                    {
                        label:'旷鹰',
                        value:1
                    },
                    {
                        label:'敏观',
                        value:2
                    }
                ],
                SXTypes:[ //神行面板机型号
                    {
                        label:'W5K-I8',
                        value:1
                    },
                    {
                        label:'W4K-E7',
                        value:2
                    },
                    {
                        label:'W4K-I5',
                        value:3
                    },
                    {
                        label:'W4K-I3',
                        value:4
                    }
                ],
                HTTypes:[ //鸿图型号
                    {
                        label:'3003',
                        value:1
                    },
                    {
                        label:'3000',
                        value:2
                    },
                    {
                        label:'2000',
                        value:3
                    }
                ],
                MFTypes:[  //魔方型号
                    {
                        label:'B3R',
                        value:1
                    },
                    {
                        label:'B4H',
                        value:2
                    },
                    {
                        label:'其他',
                        value:3
                    }
                ],
                takeAways:[  //坏件是否可以带走
                    {
                        label:'是',
                        value:1
                    },
                    {
                        label:'否',
                        value:2
                    }
                ],
                editorOption: {
                    defaultMsg: '',
                    config: {
                        initialFrameWidth: null,
                        initialFrameHeight: 350
                    }
                },
                groupId:'',
                belongId:''
            }
        },
        mounted(){
           // this.getDetail()
        },
        methods:{
            getRecords(){
                this.records=[]
                 let email=this.$store.state.email
                getRecord(this.id,email).then(res=>{  //获取活动记录
                    if(res.data.status==0){
                        if(res.data.data){
                            this.records=res.data.data ||  []
                            if(this.records.length){
                                this.records.sort((a,b)=>{
                                    return a.updatedAt-b.updatedAt;
                                })
                                this.records.forEach(item=>{
                                    if(item.updatedAt){
                                        item.updatedAt=this.format(item.updatedAt)
                                    }
                                    if(item.ownerId=='2093266063002885'){
                                        item.ownerName='我'
                                    }else{
                                        item.ownerName='旷视售后服务'
                                    }
                                    if(item.contentFile && item.contentFile.length){
                                        item.contentFile=JSON.parse(item.contentFile)
                                    }
                                })
                            }
                        }
                    }else{
                        if(res.data.msg!='未查询到信息'){
                            this.$message.error(res.data.msg)
                        }
                    }
                })
            },
            getDetail(){
               // let id=this.$route.query.id
                getCaseDetail(this.id).then(res=>{
                    for(let key in this.titleInfo){
                        this.titleInfo[key]=''
                    }
                    this.detailInfo=[]
                    this.answer=''
                    this.fileList=[]
                    if(res.data.code==200){
                        if(res.data.data){
                            let data=res.data.data
                            this.groupId=data.groupId
                            this.belongId=data.belongId
                            this.getRecords()
                            this.titleInfo.id=data.id
                            this.titleInfo.caseNo=data.caseNo
                            this.titleInfo['name']=data.name
                            this.titleInfo.caseStatus=data.caseStatus
                            this.titleInfo.createdAt=data.createdAt
                            this.titleInfo.feedback__c=data.feedback__c?data.feedback__c:'--'
                            this.titleInfo.SVCStartTime__c=data['SVCStartTime__c']
                            this.titleInfo.caseDescription=data['caseDescription']
                            this.titleInfo.typeText=''
                            this.ownerId=data.ownerId
                            this.types.forEach(item=>{
                                if(data['issueType1__c']==item.value){
                                    this.titleInfo.typeText=item.label
                                    item.children.forEach(item2=>{
                                        if(data['issueType2__c']==item2.value){
                                            this.titleInfo.typeText+='-'+item2.label
                                        }
                                    })
                                }
                            })
                            this.titleInfo.statusText=this.caseStatus.filter(item=>{
                                return item.value==this.titleInfo.caseStatus
                            })[0].label
                            let n=data.issueType2__c
                            let a=this.formItems.filter(item=>{
                                return item.value==n
                            })
                            a[0].items.forEach(item=>{
                                let obj={}
                                obj.label=item.label
                                obj.value=data[item.value]
                                let m=[]
                                //故障来源
                                if(item.value=='reportedFrom__c'){
                                    m=this.reportedFroms.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //厂商
                                if(item.value=='manufacturer__c'){
                                    m=this.manufacturers.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //所处阶段
                                if(item.value=='currentStage__c'){
                                    m=this.currentStages.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //坏件是否可以带走
                                if(item.value=='takeAway__c'){
                                    m=this.takeAways.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //交付模式
                                if(item.value=='deliverMode__c'){
                                    m=this.deliverModes.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //使用产品
                                if(item.value=='productType__c'){
                                    m=this.productTypes.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //问题分类
                                if(item.value=='issueType__c'){
                                    m=this.issueTypes.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //设备类型
                                if(item.value=='deviceType__c'){
                                    m=this.deviceTypes.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //故障出现阶段
                                if(item.value=='issueAppear__c'){
                                    m=this.issueAppears.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //配件是否齐全
                                if(item.value=='acceComplete__c'){
                                    m=this.acceCompletes.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //IPC型号
                                if(item.value=='IPCType__c'){
                                    m=this.IPCTypes.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //神行面板机型号
                                if(item.value=='SXType__c'){
                                    m=this.SXTypes.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //鸿图型号
                                if(item.value=='HTType__c'){
                                    m=this.HTTypes.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //魔方型号
                                if(item.value=='MFType__c'){
                                    m=this.MFTypes.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }
                                //受理组织
                                if(item.value=='supportOrg__c'){
                                    m=this.supportOrgs.filter(p=>{
                                        return p.value==data[item.value]
                                    })
                                }

                                obj['text']=m.length?m[0].label:''
                                this.detailInfo.push(obj)
                            })
                            this.$emit('childFn',this.titleInfo)
                        }
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })

            },
            handleExceed(files, fileList) {
                this.$message.warning('最多允许上传10个附件');
            },
            uploadFiles(){
                return new Promise((resolve,reject)=> {
                    let files=this.$refs.upload.uploadFiles
                    if(files.length){
                        let images = new FormData()
                        let imagesFlag = false
                        let size=0
                        let fileNames=[]
                        files.forEach(item => {
                            size+=item.size
                            fileNames.push(item.name)
                            imagesFlag = true
                            images.append("files", item.raw);
                        })
                        images.append('isImage', 'false')
                        images.append('fileName', fileNames)
                        if(size<this.maxSize){
                            this.uploadFile(this.fileUrl, images, imagesFlag).then(res=>{
                                resolve(res)
                            }).catch(err=>{
                                reject(err)
                            })
                        }else{
                            this.$message.warning('附件大小不能超过80M')
                            reject('附件大小不能超过80M')
                        }

                    }else{
                        resolve('success')
                    }
                })
            },
            uploadFile(url,datas,flag){
                return new Promise((resolve,reject)=>{
                    if(flag==true){
                        fileLoad(datas).then(res=>{
                            if(res.data.code==200){
                                resolve(res.data.result)
                            }else{
                                this.$message.error('附件上传出错')
                                reject('error')
                            }
                        }).catch(err=>{
                            this.$message.warning('附件上传失败')
                            reject(err)
                        })
                    }else{
                        resolve('success')
                    }
                })
            },
            updateInfo(){
                let files=this.$refs.upload.uploadFiles
                if(this.answer || files.length){
                    if(this.answerFlag){
                        this.answerFlag=false
                        this.uploadFiles().then(res=>{
                            let data={}
                            data.belongId=this.belongId
                            data.groupId=this.groupId
                            // data.itemId=this.$route.query.id
                            data.itemId=this.id
                            data.type='2290534072094039'
                            data.entityType='2290534072094039'
                           // data.ownerId='2093266063002885'
                            data.SCOwner__c=this.ownerId
                            data.serviceCase__c=this.id

                            data.content=this.answer.trim()
                            data.contentFile=[]
                            if (Array.isArray(res) && res.length) {
                                res.forEach(item => {
                                    let i = {}
                                    if (item.fileId) {
                                        i.id = item.fileId
                                    }
                                    if (Object.keys(i).length) {
                                        data.contentFile.push(i)
                                    }
                                })
                            }
                            createRecord(data).then(res=>{
                                this.answerFlag=true
                                if(res.data.code==200){
                                    this.getDetail()
                                }else{
                                    this.$message.error(res.data.msg)
                                }
                            }).catch(err=>{
                                this.answerFlag=true
                            })
                        }).catch(error=>{
                            this.answerFlag=true
                        })
                    }
                }
            },
            onChange(f, list) {
                let type=f.name.substring(f.name.lastIndexOf(".") + 1).toLocaleLowerCase()
                 let arr=['rar','zip','7z','pdf','txt','doc','docx','xls','xlsx','ppt','pptx','wps','z','gz','bmp','gif','jpg','pic','png','mp3','wma','avi','tmp']
                if(arr.indexOf(type)==-1){
                        this.$message.warning('不支持该类型文件');
                        this.$refs.upload.uploadFiles.splice(this.$refs.upload.uploadFiles.length - 1, 1)
                }else{
                     if (f.size > this.maxSize) {
                    this.$message.warning('文件太大，超出限制');
                    //这里还可以判断是否有重名文件，如果有也可以用下面的方法禁止出现在文件列表中
                    this.$refs.upload.uploadFiles.splice(this.$refs.upload.uploadFiles.length - 1, 1)
                    } 
                }
            },
            loadImg(item){
                downLoadImages(item.fileId).then(res=>{
                    if(res.data){
                        // let link=document.createElement('a')
                        // link.style.display='none'
                        // link.href=window.location.href+res.data[0].url
                        // link.setAttribute('download',res.data[0].fileName)
                        // document.body.appendChild(link)
                        // link.click()
                        let url=window.URL.createObjectURL(new Blob([res.data]))
                        let link=document.createElement('a')
                        link.style.display='none'
                        link.href=url
                        link.setAttribute('download',item.fileName)
                        document.body.appendChild(link)
                        link.click()

                    }
                })
            },
            getBase64(url){
                    let dataURL=''
                    let canvas = document.createElement('canvas')
                    let ctx=canvas.getContext('2d')
                    let img=new Image()
                    img.crossOrigin='Anonymous'
                    img.src=url
                    img.onload=function(){
                        canvas.height=300
                        canvas.width=300
                        ctx.drawImage(img,0,0,300,300)
                        dataURL=canvas.toDataURL("image/png")
                        canvas=null
                    }
                 return dataURL
            },
            add0(m) {
                return m < 10 ? '0' + m : m
            },
            format(timeStamp) {
                let str='--'
                if(timeStamp){
                    var time = new Date(Number(timeStamp));
                    var y = time.getFullYear();
                    var m = time.getMonth() + 1;
                    var d = time.getDate();
                    var h = time.getHours();
                    var mm = time.getMinutes();
                    var s = time.getSeconds();
                    str=y + '年' + this.add0(m) + '月' + this.add0(d) + '日 ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(s);
                }
                return str;
            },
            isImage(str) {
                let reg = /\.(jpeg|png|jpg|gif|ico|bpm|webp)$/i;
                return reg.test(str);
            },
            isVideo(str){
                let reg = /\.(mp4|ogg|flv|avi|wmv|rmvb|mp3)$/i;
                return reg.test(str);
            }
        }
    }
</script>

<style scoped>
    ul,li{
        list-style: none;
    }
    .info_card{
        min-width:330px;
        max-width: 340px;
        font-weight:bold;
        font-size:14px;
        position:absolute;
        /*bottom:50px;*/
        right:25px;
        top:10px;
        z-index: 999;
    }
    .info_card ul{
        padding:10px 0;
    }
    .info_card li{
        display: flex;
        line-height: 30px;
    }
    .info_card li .ft100{
        font-weight: 100;
    }
    .info_card li>span:first-of-type{
        width:71px;
    }
    .info_card li>span:last-of-type{
        flex:1;
    }
    .info_title{
        padding-bottom:5px;
        border-bottom:1px solid #DCDFE6;
    }
    .detail_title{
        margin-bottom:10px;
        line-height: 30px;
        font-weight: bold;
    }
    .record{
        width:calc(100% - 400px);
        padding:0 20px;
    }
    .record>li{
        padding:10px 0;
    }
    .ft500{
        font-weight:500;
    }
    .record_right{
        flex:2;
        width:800px;
        margin-left:15px;
        padding-bottom:10px;
        line-height: 30px;
        border-bottom:1px solid #e9e9e9;
    }
    ul.record_right>li:first-of-type{
        margin-bottom:3px;
        font-size: 15px;
    }
    .record li:last-of-type .record_right{
        border-bottom:0;
    }
    .trait{
        width:30px;
        height:30px;
        border-radius:50%;
        background:#4caf50;
        text-align: center;
        line-height: 30px;
    }
    .answer_btn_box{
        text-align: center;
        margin-top:30px;
    }
    .answer_btn_box .el-button{
        padding:12px 50px;
    }
    .column{
        display:flex;
        flex-direction: column;
    }
    .upload{
        display: flex;
        margin:10px 0;
    }
    .file_box{
        display: flex;
        flex-wrap:wrap;
        text-align: center;
        align-items: center;
    }
    .file_box>div>*{
        margin-right:30px;
        margin-bottom:20px;
    }
    .file_box img{
        width:50px;
    }
    .file_box .doc i{
        font-size:24px;
        vertical-align: middle;
    }
    .sticky{
        position: sticky;
        bottom: 0;
        background: #fff;
        z-index: 999;
    }
    .tooltip{
        display: block;
        width: 120px;
        word-break: break-all;
        font-size: 14px;
        line-height: 20px;
    }
</style>